import React from 'react'
import { useRouter } from 'next/router'
import Template from '@app/components/template'
import { translate } from '@app/locale/translate'
import { EMAIL_REGEX } from '@app/components/utils'

import { fetchServer } from '@app/store'
import Modal from '@app/components/modal'
import Alert, { getNetworkError } from '@app/components/alert'

import { useForm } from 'react-hook-form'
import { Flex, Box, Button, Text } from 'rebass'
import {
	Label,
	Input
} from '@rebass/forms'

const Forgot = () =>  {
	const router = useRouter()
  const { register, errors, handleSubmit } = useForm()

  const [resetError, setResetError] = React.useState()
  const [errorMessage, setErrorMessage] = React.useState({})
  const [alertMessage, setAlertMessage] = React.useState({})

	const onSubmit = data => {

    fetchServer(
      '/api/users/forgot-password',
      'POST',
      data
    ).then(() => {
      // success action
      setAlertMessage({
        title: translate('Thank you'),
        message: translate('Please check your email inbox, and follow the instructions to reset your password.'),
        actions: [{
          title: translate('OK'),
          class: 'primary',
          action: () => {
            router.push('/account/login')
          }
        }]
      })
    }, error => {
      if(error.response.status === 404) {
        setResetError(translate("email address not found"))
      }
      else {
        setErrorMessage(getNetworkError(error.response))
      }
    })
	}

	return (
		<Template>
			<Flex
				width={1}
				justifyContent='center'
			>
				<Box
					as='form'
					onSubmit={handleSubmit(onSubmit)}
					sx={{
						maxWidth: 450,
						flexGrow: 1
					}}
				>
					<Box
						my={16}>
						<Label mb={2} htmlFor='email'>{translate('Email')}</Label>
						<Input
							id='email'
							name='email'
							placeholder='yourname@gmail.com'
							ref={register({
								required: true,
								pattern: EMAIL_REGEX
							})}
              onChange={()=>{
                if(resetError) setResetError(null)
              }}
						/>
						<Text fontSize={1} color='accent'>{errors.email && translate("Invalid email address")}</Text>
            <Text fontSize={1} color='accent'>{resetError}</Text>
					</Box>
					<Button mt={16} type="submit">
						{translate('Reset Password')}
					</Button>
				</Box>
			</Flex>
      <Alert
        open={errorMessage.title !== undefined}
        title={errorMessage.title}
        message={errorMessage.message}
        onClose={() => { setErrorMessage({}) }}
      ></Alert>

      <Modal
        open={alertMessage.title !== undefined}
        title={alertMessage.title}
        message={alertMessage.message}
        actions={alertMessage.actions}
        onClose={() => {
          router.push('/account/login')
        }}
      ></Modal>
		</Template>
	)
}

export default Forgot
